import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';
import VueBreadcrumbs from 'vue-2-breadcrumbs';
import i18n from '@/libs/i18n';
import { initLogRocket } from '@/libs/logrocket';
import router from './router';
import store from './store';
import App from './App.vue';
import '@validations';

// Global Components
import './global-components';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/toastification';
import '@/libs/dayjs';
import '@/libs/sweet-alerts';
import '@/libs/vue-select';
import { hasRole } from './@core/directives/hasRole';

// LogRocket Initialization
initLogRocket();

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
// Composition API
Vue.use(VueCompositionAPI);

// Breadcrumb
Vue.use(VueBreadcrumbs, {
  template:
    '        <nav v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
    '            <ol class="breadcrumb px-0">\n' +
    '                <li v-for="(crumb, key) in $breadcrumbs.filter(i => i.meta.breadcrumb)" :key="key" :class="{active: getPath(crumb) === $route.path}" class="breadcrumb-item" aria-current="page">\n' +
    '                    <router-link v-if="getPath(crumb) !== $route.path" :to="{ path: getPath(crumb) }">{{ $t(getBreadcrumb(crumb.meta.breadcrumb)) }}</router-link>' +
    '                </li>\n' +
    '            </ol>\n' +
    '        </nav>'
});

Vue.directive('has-role', hasRole);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
